import type { KnowledgeItem } from '@/types';

// 阳极焙烧炉车间知识库（15 条）
export const bakingKnowledge: KnowledgeItem[] = [
  // ========== 工艺基础 ==========
  {
    id: 'BK-K001',
    tags: ['焙烧', '工艺', '基础'],
    question: '阳极焙烧的目的是什么？',
    answer: '生阳极在 1100°C 焙烧 25~30 天，目的：①排出沥青中挥发分（≈ 18%）②碳骨架重排固化 ③电阻率从 80 μΩ·m 降到 55 μΩ·m，让阳极能承受电解槽 950°C 高温 + 500 kA 电流。',
  },
  {
    id: 'BK-K002',
    tags: ['焙烧周期', '工艺'],
    question: '焙烧周期是怎么划分的？',
    answer: '总周期 25~30 天，分 5 段：①装炉 1 天 ②升温 500→900°C 8 天 ③高温升温 900→1100°C 6 天 ④恒温 1100°C 3 天 ⑤降温 900→200°C 7~10 天。',
  },
  {
    id: 'BK-K003',
    tags: ['升温曲线', '工艺', '关键参数'],
    question: '升温速率为什么要 ≤ 12°C/h？',
    answer: '升温过快 → 沥青挥发分爆冲 → 阳极内部气泡膨胀 → 表面起鼓/开裂；正常 8~12°C/h，关键升温段 500→800°C 必须严控到 8°C/h。',
  },
  {
    id: 'BK-K004',
    tags: ['恒温', '工艺', '关键参数'],
    question: '恒温 1100°C 阶段最关键是什么？',
    answer: '左右火道温差 ≤ 20°C 是命脉。温差大 → 阳极一边焦一边生 → 抗折强度差异 → 电解槽用时局部断裂掉块。',
  },
  {
    id: 'BK-K005',
    tags: ['负压', '抽烟', '关键参数'],
    question: '为什么炉室要保持负压？',
    answer: '炉室负压 -300~-400 Pa：①让燃烧产生的废气走烟道，不从炉门外漏 ②保证空气从受控通道进入助燃 ③抽烟不足 → 黑烟外冒 + 局部缺氧 → 焙烧不充分。',
  },

  // ========== 5 大典型缺陷 ==========
  {
    id: 'BK-K101',
    tags: ['缺陷', '温度梯度', '故障'],
    question: '炉室左右温差大怎么处理？',
    answer: '温差 > 20°C 立即干预：①降燃料气流量 20% ②提高抽烟负压到 -350 Pa ③检查火道是否堵塞。30 分钟内如果不改善，停炉检查。',
  },
  {
    id: 'BK-K102',
    tags: ['缺陷', '燃料气', '故障'],
    question: '燃料气压力波动大怎么办？',
    answer: '波动 > 30% 通知调度。先稳调压阀到 10 kPa，再排查上游母管。波动短期内 → 加大缓冲罐压力；长期 → 检查调压阀响应时间。',
  },
  {
    id: 'BK-K103',
    tags: ['缺陷', '抽烟', '故障'],
    question: '炉口冒黑烟说明什么？',
    answer: '抽烟不足 + 炉室正压。立即：①提抽烟机转速到 1500 rpm ②检查烟道是否积焦 ③禁止关炉门（会更缺氧）。黑烟是 PAH 致癌物，外冒必须立刻处理。',
  },
  {
    id: 'BK-K104',
    tags: ['缺陷', '炉室漏气', '故障'],
    question: '炉室漏气怎么判断？',
    answer: '保压试验：关闭进气，测温度/压力下降速率。正常 < 3°C/min 或 < 5%/min 压力损失。超过即漏气。常见漏点：①炉门密封圈 ②观察孔密封 ③耐火砖缝。',
  },
  {
    id: 'BK-K105',
    tags: ['缺陷', '焦床', '故障'],
    question: '焦床薄了会怎样？',
    answer: '焦床 < 80 mm → 阳极顶部裸露在 1100°C + O₂ 环境 → 表面被氧化 → 电阻率上升 + 表面脱皮。出炉时见到表面有 "灰白色" 区域就是氧化区，要剔除。',
  },

  // ========== 质量与参数 ==========
  {
    id: 'BK-K201',
    tags: ['电阻率', '质量', '工艺'],
    question: '熟阳极电阻率达标是多少？',
    answer: '出厂熟阳极电阻率 50~60 μΩ·m。每高 5 μΩ·m，电解槽吨铝多耗 100~150 kWh。所以焙烧温度曲线 + 焦床覆盖直接影响下游能耗。',
  },
  {
    id: 'BK-K202',
    tags: ['挥发分', '质量', '工艺'],
    question: '生阳极挥发分焙烧后还剩多少？',
    answer: '生阳极挥发分含量 14~16 wt%。焙烧后熟阳极挥发分 < 0.5 wt%。挥发分主要在 300~800°C 阶段排出，所以这段升温要慢。',
  },
  {
    id: 'BK-K203',
    tags: ['抗折强度', '质量', '工艺'],
    question: '熟阳极抗折强度要求多少？',
    answer: '电解槽用阳极抗折强度 ≥ 8 MPa（GB/T 8742）。强度由焙烧温度曲线 + 升温速率 + 焦床均匀度共同决定。',
  },

  // ========== 设备与安全 ==========
  {
    id: 'BK-K301',
    tags: ['设备', '维护', '抽烟机'],
    question: '抽烟机日常维护重点是什么？',
    answer: '①每班记录电流和振动 ②每周清理叶轮积尘 ③每月查变频器和轴承温度（< 85°C）④每年大修。叶轮积尘是引风量下降的最常见原因。',
  },
  {
    id: 'BK-K302',
    tags: ['安全', '高温', '操作'],
    question: '焙烧车间高温作业要注意什么？',
    answer: '①炉室周边温度 80°C，戴防火服+防火面罩 ②熟阳极 200+°C 余温，戴隔热手套 ③禁止单人作业 ④发现燃料气泄漏立即停气、撤离、通风。',
  },
];
